export const logoMaxSizeBytes = 2097152;
export const fileMaxSize = 5242880; // 5mb
export const filePsmMaxSize = 20; // 20mb
